/*@ngInject*/
const WizardActionUtil = function ($q, submissionConstant, submissionActionsRepository, quoteActionsRepository, reportActionsRepository,
                                   policyIssuanceActionsRepository, proposalActionsRepository, policyActionsRepository, policyCancellationActionsRepository,
                                   endorsementActionsRepository, policyRewriteActionsRepository) {

    var allActionsPromise = null;

    // Possible ids include: submissionId, quoteId, reportId, policyIssuanceId, proposalId, policyId, policyCancellationId, and endorsementId
    this.getAllActions = function (ids) {
        var promisesList = [],
            actionPromise,
            quotePromise,
            reportPromise,
            policyIssuancePromise,
            proposalPromise,
            policyPromise,
            policyCancellationPromise,
            endorsementPromise,
            policyRewritePromise,
            emptyPromise;

        if (allActionsPromise) {
            return allActionsPromise;
        }

        if (ids.submissionId) {
            actionPromise = submissionActionsRepository.loadSubmissionActions(ids.submissionId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_SUBMISSION;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });

            promisesList.push(actionPromise);
        }

        if (ids.quoteId) {
            quotePromise = quoteActionsRepository.loadQuoteActions(ids.quoteId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_QUOTE;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });
            promisesList.push(quotePromise);
        }

        if (ids.reportId) {
            reportPromise = reportActionsRepository.loadReportActions(ids.reportId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_REPORT;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });
            promisesList.push(reportPromise);
        }

        if (ids.policyIssuanceId) {
            policyIssuancePromise = policyIssuanceActionsRepository.loadPolicyIssuanceActions(ids.policyIssuanceId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_POLICY_ISSUANCE;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });
            promisesList.push(policyIssuancePromise);
        }

        if (ids.proposalId) {
            proposalPromise = proposalActionsRepository.loadProposalActions(ids.proposalId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_PROPOSAL;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });
            promisesList.push(proposalPromise);
        }

        if (ids.policyId) {
            policyPromise = policyActionsRepository.loadPolicyActions(ids.policyId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_POLICY;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });
            promisesList.push(policyPromise);
        }

        if (ids.policyCancellationId) {
            policyCancellationPromise = policyCancellationActionsRepository.loadPolicyCancellationActions(ids.policyCancellationId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_POLICY_CANCELLATION;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });
            promisesList.push(policyCancellationPromise);
        }

        if (ids.endorsementId) {
            endorsementPromise = endorsementActionsRepository.loadEndorsementActions(ids.endorsementId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_ENDORSEMENT;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });
            promisesList.push(endorsementPromise);
        }

        if (ids.policyRewriteId) {
            policyRewritePromise = policyRewriteActionsRepository.loadPolicyRewriteActions(ids.policyRewriteId).then(function (responseData) {
                var actions = {};

                actions['contextType'] = submissionConstant.CONTEXT_POLICY_REWRITE;
                if (responseData === null) {
                    actions['actions'] = null;
                } else {
                    actions['actions'] = responseData.actions;
                }

                return actions;
            });
            promisesList.push(policyRewritePromise);
        }

        if (promisesList.length === 0) {
            emptyPromise = $q.defer();
            emptyPromise.resolve([]);
            return emptyPromise.promise;
        }

        allActionsPromise = $q.all(promisesList);

        return allActionsPromise;
    };

    this.resetActions = function () {
        allActionsPromise = null;
    };

    this.getActionIds = function (hierarchicalContextList) {
        var actionIds = {};

        _.each(hierarchicalContextList, function (hierarchicalContext) {
            if (hierarchicalContext.contextType === submissionConstant.CONTEXT_SUBMISSION) {
                actionIds.submissionId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_QUOTE) {
                actionIds.quoteId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_REPORT) {
                actionIds.reportId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_ISSUANCE) {
                actionIds.policyIssuanceId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_PROPOSAL) {
                actionIds.proposalId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY) {
                actionIds.policyId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_CANCELLATION) {
                actionIds.policyCancellationId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_ENDORSEMENT) {
                actionIds.endorsementId = hierarchicalContext.contextId;
            } else if (hierarchicalContext.contextType === submissionConstant.CONTEXT_POLICY_REWRITE) {
                actionIds.policyRewriteId = hierarchicalContext.contextId;
            }
        });

        return actionIds;
    };
};

angular.module('gw-um-submission')
    .service('wizardActionUtil', WizardActionUtil);
